import { ImageObj } from '../../interface/image-obj';

export class Brand {
    name: string;
    id: number;
    image: ImageObj;
    active: boolean;
}